"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProgressOvertime = exports.useGetNeedResponsesCount = exports.useEditBulkObjectives = exports.useGetTotalObjectives = exports.useGetObjectives = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const objectivesKeys_1 = __importDefault(require("consts/queryKeys/objectivesKeys"));
const useGetObjectives = (page, params, options) => {
    const fetchObjectives = (olderThan, signal) => {
        return (0, ObjectivesClient_1.getListObjectives)({ ...params, olderThan }, signal);
    };
    return (0, react_query_1.useInfiniteQuery)(objectivesKeys_1.default.objectives(page, params), ({ pageParam, signal }) => fetchObjectives(pageParam, signal), {
        getNextPageParam: (lastPage) => {
            return lastPage?.pagination?.next?.olderThan;
        },
        ...options
    });
};
exports.useGetObjectives = useGetObjectives;
const useGetTotalObjectives = (params, options) => {
    const fetchTotalObjectives = (signal) => {
        return (0, ObjectivesClient_1.getTotalObjectives)(params, signal);
    };
    return (0, react_query_1.useQuery)(objectivesKeys_1.default.totalObjectives(params), ({ signal }) => fetchTotalObjectives(signal), options);
};
exports.useGetTotalObjectives = useGetTotalObjectives;
const useEditBulkObjectives = () => {
    return (0, react_query_1.useMutation)(async (body) => {
        const response = await (0, ObjectivesClient_1.updateBulkObjective)(body);
        if (response?.isSuccess) {
            return response;
        }
        throw response;
    });
};
exports.useEditBulkObjectives = useEditBulkObjectives;
const useGetNeedResponsesCount = (type, params, options) => {
    const fetchNeedResponsesCount = () => {
        return (0, ObjectivesClient_1.getNeedResponses)(params);
    };
    return (0, react_query_1.useQuery)(objectivesKeys_1.default.needResponseCount(type, params), fetchNeedResponsesCount, options);
};
exports.useGetNeedResponsesCount = useGetNeedResponsesCount;
const useGetProgressOvertime = (id, page, params, options) => {
    const fetchProgressOvertime = (olderThan, signal) => {
        return (0, ObjectivesClient_1.getProgressOvertimeData)(id, { ...params, olderThan }, signal);
    };
    return (0, react_query_1.useInfiniteQuery)(objectivesKeys_1.default.objectives(page, params), ({ pageParam, signal }) => fetchProgressOvertime(pageParam, signal), {
        getNextPageParam: (lastPage) => {
            return lastPage?.pagination?.next?.olderThan;
        },
        ...options
    });
};
exports.useGetProgressOvertime = useGetProgressOvertime;
